import { render, staticRenderFns } from "./dialog-tax-reminder.vue?vue&type=template&id=6befe92c&scoped=true"
import script from "./dialog-tax-reminder.vue?vue&type=script&lang=js"
export * from "./dialog-tax-reminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6befe92c",
  null
  
)

export default component.exports